export const isArrayEqual = <T>(array1: T[], array2: T[]) =>
  array1.length === array2.length &&
  array1.every((val) => array2.includes(val));
